module.exports = __webpack_public_path__ + "static/img/icon4-11.c1694028.png";